import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import ServiceSelector from './components/ServiceSelector';
import ROICalculator from './components/ROICalculator';
import TransformationTimeline from './components/TransformationTimeline';
import ClientLogos from './components/ClientLogos';
import logo from '../../../public/assets/images/fibrelogo.png';


const Homepage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <HeroSection />
        <ServiceSelector />
        {/* <ROICalculator /> */}
        <TransformationTimeline />
        <ClientLogos />
      </main>
      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <img
                                src={logo}
                                    alt="Xtreem Fibre Solutions"
                                    width={80}
                                    height={80}
                                    className="h-16 w-auto brightness-0 invert transition-transform duration-300 group-hover:scale-105"/>
                                
                <div>
                  <h3 className="text-lg font-bold">Xtreem Fibre Solutions</h3>
                  <p className="text-xs text-slate-400 font-mono">Infrastructure Transformation</p>
                </div>
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">
                Transforming businesses through future-ready fiber optic infrastructure. 
                Seamless transitions, minimal disruption, maximum performance.
              </p>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-sm text-slate-300">
                  <li><a href="/copper-to-fiber-conversion-service" className="hover:text-white transition-colors">Fibre Optics</a></li>
                <li><a href="/network-assessment-tool" className="hover:text-white transition-colors">Technical Support</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Emergency Support</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Maintenance Plans</a></li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-sm text-slate-300">              
                <li><a href="/about-expertise" className="hover:text-white transition-colors">About Us</a></li>
                <li><a href="/service-areas-local-teams" className="hover:text-white transition-colors">Service Areas</a></li>
                <li><a href="/get-quote-consultation" className="hover:text-white transition-colors">Contact Us</a></li>                
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <div className="space-y-3 text-sm text-slate-300">
                <div>
                  <p className="font-medium text-white">Emergency: 24/7</p>
                  <p>01483 343 064</p>
                </div>
                <div>
                  <p className="font-medium text-white">General Inquiries</p>
                  <p>admin@xtreemfibresolutions.co.uk</p>
                </div>
                <div>
                  <p className="font-medium text-white">Business Hours</p>
                  <p>Mon-Fri: 8AM-6PM EST</p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm">
              © {new Date()?.getFullYear()} Xtreem Fibre Solutions. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              {/* <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Privacy Policy</a> */}
              <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Terms of Service</a>
              {/* <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">Cookie Policy</a> */}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;